import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import ReferralForm from "./pages/ReferralForm";
import StatusPage from "./pages/StatusPage";
import MyCases from "./pages/MyCases";
import Login from "./pages/Login";
import Landing from "./pages/Landing";
import Profil from "./pages/Profil";
import { ForgotPassword, ResetPassword } from "./pages/PasswordPages";
import CaseList from "./pages/CaseList";
import CaseDetail from "./pages/CaseDetail";
import Report from "./pages/Report";
import Settings from "./pages/Settings";
import Legal from "./pages/Legal";
import { PraxisShell } from "./components/PraxisShell";
import Register, { InvitationPage, UnsubscribePage } from "./pages/Register";
import { UebDashboard, UebFachpraxen, UebKollegen, UebShell, UebTeam } from "./pages/UebArea";
import PraxisInvites from "./pages/PraxisInvites";
import { PruefFaelle, PruefFallDetail, PruefStatistik, PruefUeberweiser } from "./pages/Pruefung";
import { FeedbackAdmin, FehlerLog } from "./pages/FeedbackAdmin";
import { PreviewCase } from "./pages/StatusPage";
import { FeedbackButton, TestBanner } from "./components/Global";

export default function App() {
  return (
    <BrowserRouter>
      <Toaster position="bottom-right" closeButton toastOptions={{ classNames: { toast: "!bg-surface !text-text !border-border", success: "!bg-success-bg !text-success", error: "!bg-danger-bg !text-danger" } }} />
      <TestBanner />
      <FeedbackButton />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/passwort-vergessen" element={<ForgotPassword />} />
        <Route path="/passwort-zuruecksetzen" element={<ResetPassword />} />
        <Route path="/u/:slug" element={<ReferralForm />} />
        <Route path="/f/:token" element={<StatusPage />} />
        <Route path="/meine-faelle" element={<MyCases />} />
        <Route path="/impressum" element={<Legal title="Impressum" />} />
        <Route path="/datenschutz" element={<Legal title="Datenschutz" />} />
        <Route path="/nutzungsbedingungen" element={<Legal title="Nutzungsbedingungen" />} />
        <Route path="/registrieren" element={<Register />} />
        <Route path="/einladung/:token" element={<InvitationPage />} />
        <Route path="/abmelden" element={<UnsubscribePage />} />
        <Route path="/ueberweiser" element={<UebShell />}>
          <Route index element={<UebDashboard />} />
          <Route path="fachpraxen" element={<UebFachpraxen />} />
          <Route path="team" element={<UebTeam />} />
          <Route path="kollegen" element={<UebKollegen />} />
          <Route path="profil" element={<Profil ueb />} />
        </Route>
        <Route path="/praxis/vorschau/:upId" element={<UebShell />}>
          <Route index element={<UebDashboard />} />
          <Route path="fachpraxen" element={<UebFachpraxen />} />
          <Route path="team" element={<UebTeam />} />
          <Route path="kollegen" element={<UebKollegen />} />
          <Route path="f/:token" element={<PreviewCase />} />
        </Route>
        <Route path="/praxis" element={<PraxisShell />}>
          <Route path="pruefung" element={<Navigate to="faelle" replace />} />
          <Route path="pruefung/faelle" element={<PruefFaelle />} />
          <Route path="pruefung/faelle/:id" element={<PruefFallDetail />} />
          <Route path="pruefung/statistik" element={<PruefStatistik />} />
          <Route path="pruefung/ueberweiser" element={<PruefUeberweiser />} />
          <Route path="feedback" element={<FeedbackAdmin />} />
          <Route path="fehler" element={<FehlerLog />} />
          <Route path="ueberweiser/einladen" element={<PraxisInvites />} />
          <Route index element={<Navigate to="faelle" replace />} />
          <Route path="faelle" element={<CaseList />} />
          <Route path="faelle/:id" element={<CaseDetail />} />
          <Route path="faelle/:id/bericht" element={<Report />} />
          <Route path="einstellungen" element={<Settings />} />
          <Route path="profil" element={<Profil />} />
        </Route>
        <Route path="*" element={<Legal title="Seite nicht gefunden" text="Die angeforderte Seite existiert nicht." />} />
      </Routes>
    </BrowserRouter>
  );
}
